<template>
	<div class="bodycont">
		<div class="Pub_flexrow Pub_width">
			<div class="fl">
				<div class="flmenu" :class="activeindex==index?'flmenuactive':''" v-for="(item,index) in cont_data" @click="getcont(item.scode,item.type,index)">
					<img :src="$Pub_url+item.ico" class="flmenuicon"/>
					<div class="fltext">{{item.name}}</div>
				</div>
			</div>
			<div class="fl_mesgcont">
				 <div class="listcont" v-if="type==2">
					 <newlist v-if="scode!=14&&scode!=50" :listdata="listdata"></newlist>
					 <div v-if="scode==14" class="peoplecont">
						 <div class="currenttit Pub_flexrow">
						 	  <div class="currentcard" :class="currentindex==index?'currentcard_active':''" v-for="(item,index) in zuzhijiagou" @click="currentcli_zuzhi(item.scode,index)">
						 	  {{item.name}}
						 	  </div>
						 </div>
						   <div class="toppeople Pub_flexrow">
							   <div class="peoplemenu" v-for="(item,index) in listdata" v-if="item.istop==1" @click="navto(item.id,item.outlink)">
								   <img :src="$Pub_url+item.ico" class="peopleimg"/>
								   <div class="peoplename">{{item.title}}</div>
								   <div class="peoplejob">{{item.tags}}</div>
								   <div class="peoplecompany">{{item.source}}</div>
							   </div>
						   </div>
						<!--   <div style="font-size: 16px;
										color: #005b9f;
										font-weight: bold;
										margin-top: 10px;
										margin-left: 10px;
										padding-top: 20px;
										">以下按照拼音排序</div> -->
						   <div class="toppeople bottompeople Pub_flexrow">
							   <div class="peoplemenu" v-for="(item,index) in listdata" v-if="item.istop!=1" @click="navto(item.id,item.outlink)">
								   <img :src="$Pub_url+item.ico" class="peopleimg"/>
								   <div class="peoplename">{{item.title}}</div>
								   <div class="peoplejob">{{item.tags}}</div>
								   <div class="peoplecompany">{{item.source}}</div>
							   </div>
						   </div>
					 </div>
					 
					 <div v-if="scode==50" class="peoplecont">
						 <div class="blocktitle Pub_flexrowcenter">
						 			 <div class="titlehr"></div>
						 			 <div>合作伙伴</div>
						 			 <div class="titlehr"></div>
						 </div>
						   <div class="toppeople bottompeople Pub_flexrow" style="width: 96%;">
							   <div class="peoplemenu" v-for="(item,index) in listdata" v-if="item.istop!=1" @click="navto(item.id,item.outlink)">
								   <img :src="$Pub_url+item.ico" class="peopleimg" style="width: 175px;"/>
							   </div>
						   </div>
					 </div>
				 </div>
				 <div class="richtxt" v-if="type==1&&scode!=38&&scode!=40" v-html="richtxt.content">		 
				 </div>
				 <div v-if="scode==38&&type==1" class="peoplecont">
					   <div class="toppeople bottompeople Pub_flexrow" style="width: 90%;">
						   <div class="search ">
							  <div class="inputcont Pub_flexrow">
								  <div class="inputtext">联系人</div>
								  <input type="text" placeholder="请输入联系人" class="inputdom" v-model="userinput.contacts"/>
							  </div>
							  <div class="inputcont Pub_flexrow">
								  <div class="inputtext">手机</div>
								  <input type="text" placeholder="请输入手机号" class="inputdom" v-model="userinput.mobile"/>
							  </div>
							  <div class="inputcont Pub_flexrow">
								  <div class="inputtext">留言内容</div>
								  <textarea type="text" style="width: 500px;height: 300px;padding: 10px;" placeholder="请输入留言内容" class="inputdom" v-model="userinput.content"/>
							  </div>
							  <div class="searchbtn" @click="submitcont()">提交</div>
						   </div>
					   </div>
				 </div>
				 
				 <div v-show="scode==40&&type==1" class="mesgcont  Pub_flexrow">
				 	<div class="mesgrich">
				 		<div class="richtext" v-html="callus_richtxt.content"></div>
				 	</div>
				 	<div class="map">
				 		<div class="mapcont">
				 			<div class="maptitle">{{maptitle}}</div>
				 			<div id="container"></div>
				 		</div>
				 	</div>
				 </div>
				 
				 <div v-show="scode==16&&type==1" class="mesgcont">
					<div class="currenttit Pub_flexrow">
						  <div class="currentcard" :class="currentindex==index?'currentcard_active':''" v-for="(item,index) in zhuyaochengyuan" @click="currentcli(item.scode,index)">
						  {{item.name}}
						  </div>
					</div>
					<div class="richtext" v-html="richtext16"></div>
				 </div>
			</div>
		</div>
	</div>
</template>

<script>
	import newlist from '../components/list.vue'
	export default({
		data(){
			return{
				activeindex:0,
				cont_data:[],//页面内容
				type:null,
				listdata:[],
				richtxt:"",
				richtext16:"",
				scode:null,
				userinput:{
					contacts:"" ,//联系人
					mobile:"", //手机号
					content:"" //内容
				},
				callus_richtxt:{},
				maptitle:"",
				zhuyaochengyuan:[],
				currentindex:0
			}
		},
		components:{
			newlist
		},
		watch:{
		   '$route.query.scode':function(newv,oldv){
			   this.load_Fllist();
		   },
		   deep:true
		},
		methods:{
			navto(id,outlink){
				if(outlink){
				window.open(outlink)
				return;
				}
				this.$router.push({name:"detail",query:{id}})
			},
			currentcli(scode,index){
				this.currentindex=index
				this.$Get("api.php/about/"+scode).then(res=>{
					this.richtext16=res.data.data.content
				})
			},
			currentcli_zuzhi(scode,index){
				this.currentindex=index
				this.$Get("api.php/list/"+scode).then(res=>{
					this.listdata=res.data.data
				})
			},
			load_Fllist(){
				let scode=this.$route.query.scode
				this.$Get("api.php/cms/nav/scode/"+scode).then(res=>{
					let data=res.data.data
					this.cont_data=res.data.data
					this.getcont(data[0].scode,data[0].type);
					this.activeindex=0
				})
			},
			getcont(scode,type,index){
				this.type=type
				this.activeindex=index
				this.scode=scode
				this.richtxt=""
				// 获取富文本的
				if(type==1){
					this.$Get("api.php/about/"+scode).then(res=>{
						this.richtxt=res.data.data
					})
				}else{
				// 获取列表的
				this.$Get("api.php/list/"+scode).then(res=>{
					this.listdata=res.data.data
				  })
				}
				if(scode==16){
					this.$Get("api.php/cms/nav/scode/"+scode).then(res=>{
						this.zhuyaochengyuan=res.data.data
						this.currentcli(res.data.data[0].id,0)
					})
				}
				if(scode==14){
					this.$Get("api.php/cms/nav/scode/"+scode).then(res=>{
						this.zuzhijiagou=res.data.data
						this.currentcli_zuzhi(res.data.data[0].id,0)
					})
				}
			},
			submitcont(){
				if(this.userinput.contacts==""){
					this.$Toast({
						 message: "请输入联系人",
						 position: 'middle',
						 duration: 1000
					})
					return
				}
				if(this.userinput.mobile==""){
					this.$Toast({
						 message: "请输入联系方式",
						 position: 'middle',
						 duration: 1000
					})
					return
				}
				if(this.userinput.mobile.length<11){
					this.$Toast({
						 message: "联系方式不正确",
						 position: 'middle',
						 duration: 1000
					})
					return
				}
				this.$Get("api.php/cms/addmsg",this.userinput,"get").then(res=>{
					if(res.data.code==1){
						this.$Toast({
							 message: res.data.data,
							 position: 'middle',
							 duration: 1000
						})
						this.userinput.contacts=""
						this.userinput.mobile=""
						this.userinput.content=""
					}
					else{
						this.$Toast({
							 message: "留言失败",
							 position: 'middle',
							 duration: 1000
						})
					}
				})
				
			},
			
			loaddetail(){
				this.$Get('api.php/about/49').then(res=>{
					this.callus_richtxt=res.data.data
				})
				this.$Get('api.php/cms/company/name/jingweidu').then(res=>{
				    let late=res.data.data.split(",")
					this.loadmap(late[0],late[1]);
				})
				this.$Get('api.php/cms/company/name/other').then(res=>{
				    this.maptitle=res.data.data
				})
				
			},
			loadmap(late_num,longte_num){
				 var map = new BMapGL.Map('container');
				 map.centerAndZoom(new BMapGL.Point(late_num,longte_num), 15);
				 map.enableScrollWheelZoom(true);
				 // 创建点标记
				 var marker1 = new BMapGL.Marker(new BMapGL.Point(late_num,longte_num));
				 // 在地图上添加点标记
				 map.addOverlay(marker1);	
			}
		},
		created() {
			this.load_Fllist();
			this.loaddetail();
		},
		mounted() {
			
		},
		activated() {
			
		}
	})
</script>

<style scoped="scoped">
	.bodycont{
		margin-top: 20px;
	}
	.fl{
		width: 10%;
		min-height: 662px;
		border-radius: 5px;
		box-sizing: border-box;
		background: white;
	}
	.flmenu{
		border: 1px solid transparent;
	}
	.flmenuactive{
		border: 1px solid #005b9f;
		border-radius: 5px;
	}
	.flmenu:hover{
		border: 1px solid #005b9f;
		border-radius: 5px;
	}
	.flmenuicon{
		width: 43px;
		height: 45px;
		display: block;
		margin: 0 auto;
		padding-top:10px ;
	}
	.fltext{
		padding: 10px 0px;
		font-size: 16px;
		text-align: center;
		cursor: default;
	}
	.fl_mesgcont{
		width: 89%;
		margin-left: 1%;
		min-height: 662px;
		border-radius: 5px;
		background: white;
	}
	.listcont{
		padding: 10px;
	}
	.richtxt{
		padding: 10px;
	}
	
	.toppeople{
		width: 85%;
		margin: 0 auto;
		justify-content: flex-start;
		text-align: center;
		flex-wrap: wrap;
	}
	.peoplemenu{
		margin-top: 10px;
		margin-left: 10px;
		margin-right:45px;
	}
	.peopleimg{
		width: 140px;
	}
	.peoplename{
		font-weight: bold;
		padding:0 0 10px 0px;
	}
	.blocktitle{
		font-weight: bold;
		text-align: center;
		font-size: 20px;
		padding: 20px 0px 5px 0px;
		color: #024287;
		justify-content: center;
		white-space: nowrap;
	}
	.titlehr{
		width:500px;
		height: 2px;
		margin-left: 20px;
		margin-right: 20px;
		border-radius: 5px;
		background: #ECECEC;
	}
	
	
	
	
	
	.inputtext{
		font-size: 14px;
		padding-right: 5px;
		width: 80px;
		white-space: nowrap;
		text-align: right;
		margin-right: 20px;
	}
	.inputcont{
		margin-right: 20px;
		align-items: center;
		margin-top: 30px;
		align-items: flex-start;
	}
	.inputdom{
		padding: 5px;
		border-radius: 5px;
		border: 1px solid rgb(68,138,202);
		outline: none;
	}
	.searchbtn{
		background:rgb(68,138,202);
		width: 80px;
		white-space: nowrap;
		color: white;
		height: 25px;
		line-height: 25px;
		text-align: center;
		font-size: 14px;
		border-radius: 5px;
		cursor: default;
		float: right;
		margin-top: 20px;
		margin-right: 20px;
	}
	
	
	
	
	.mesgcont{
		background: white;
		min-height: 500px;
		margin-top: 20px;
	}
	.map{
		width: 600px;
		height: 500px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.mapcont{
		width: 447px;
		height: 400px;
	    border: 1px solid #f9e0e2;
	    border-radius: 5px;
	    padding: 10px 20px 10px 20px;
	    margin-bottom: 0px;
	}
	.maptitle{
		font-size: 15px;
		padding: 10px 0px 10px 0px;
	}
	#container{
		width: 447px;
		height: 300px;
	}
	.mesgrich{
		width: 600px;
	}
	.richtext{
		padding: 20px;
		
	}
	
	
	
	
	/* 切换标题 */
	.currenttit{
		white-space: nowrap;
		border-bottom-width: 2px;
		border-bottom-style: solid;
		border-bottom-color: #e5e5e5;
		margin-bottom: 10px;
		padding-left: 30px;
		height: 50px;
	}
	.currentcard{
		width: 100px;
		padding: 10px 0px;
		text-align: center;
		margin-right: 70px;
		border-bottom: 1px solid transparent;
		cursor: pointer;
	}
	.currentcard_active{
		border-bottom: 2px solid rgb(95,184,120);
	}
</style>



// WEBPACK FOOTER //
// src/view/FL_page.vue